const ApplyingAs = {
  NON_SELLING_PRINCIPAL: "Non-Selling Principal",
  SELLING_PRINCIPAL: "Selling Principal",
  ADVISER: "Adviser",
};

export default ApplyingAs;
